import { render, staticRenderFns } from "./XmlViewer.vue?vue&type=template&id=51525be3"
import script from "./XmlViewer.vue?vue&type=script&lang=js"
export * from "./XmlViewer.vue?vue&type=script&lang=js"
import style0 from "./XmlViewer.vue?vue&type=style&index=0&id=51525be3&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51525be3')) {
      api.createRecord('51525be3', component.options)
    } else {
      api.reload('51525be3', component.options)
    }
    module.hot.accept("./XmlViewer.vue?vue&type=template&id=51525be3", function () {
      api.rerender('51525be3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/XmlViewer/XmlViewer.vue"
export default component.exports